export const idDynamicRouteSegment = 'id'
export const typeDynamicRouteSegment = 'type'
export const orderIdDynamicRouteSegment = 'orderId'
export const productSlugDynamicRouteSegment = 'productSlug'
